module.exports = __webpack_public_path__ + "img/betfair-logo.877b67b0.svg";